export const SHOW_NEXT_SCREEN_INTERVAL = 7000
